var map = {
	"./AboutUs/Features/Mission.webp": 1066,
	"./AboutUs/Features/Values.webp": 3314,
	"./AboutUs/Features/vision.webp": 9200,
	"./AboutUs/Team/ceo.webp": 7231,
	"./AboutUs/Team/cmo.webp": 8711,
	"./AboutUs/Team/cto.webp": 4970,
	"./Blogs/certified_refurbished_datacenter_hardware.webp": 134,
	"./Blogs/choose_right_hardware.webp": 5253,
	"./Blogs/colocation_benefits.webp": 4874,
	"./Blogs/colocation_cost_guide.webp": 8116,
	"./Blogs/colocation_vs_cloud_hosting.webp": 6694,
	"./Blogs/colocation_vs_dedicated.webp": 7911,
	"./Blogs/data_center_tier_levels_explained.webp": 2148,
	"./Blogs/datacenter_hardware_validation_test_cases.webp": 39,
	"./Blogs/how_to_choose_colocation_provider.webp": 6654,
	"./Blogs/it_knowledgebase_better_operations.webp": 9897,
	"./Blogs/optimize_IT_Infrastructure.webp": 1685,
	"./Blogs/preventive_management.webp": 8442,
	"./Blogs/rigorous_testing_refurbished_it_equipment.webp": 9448,
	"./Blogs/smart_it_investment_refurbished_hardware.webp": 3180,
	"./Blogs/sustainable_datacenter_hardware.webp": 3120,
	"./Blogs/vps_vs_dedicated_server.webp": 3349,
	"./HeaderIcons/about-us.png": 7402,
	"./HeaderIcons/careers.png": 5249,
	"./HeaderIcons/certificates.png": 2190,
	"./HeaderIcons/cloud.png": 383,
	"./HeaderIcons/colocation.png": 9421,
	"./HeaderIcons/consultation.png": 5953,
	"./HeaderIcons/engineers.png": 8418,
	"./HeaderIcons/hardware.png": 2006,
	"./HeaderIcons/linux.png": 4798,
	"./HeaderIcons/microsoft.png": 8572,
	"./HeaderIcons/partners.png": 2867,
	"./HeaderIcons/priLogo.png": 9162,
	"./HeaderIcons/security.png": 4200,
	"./HeaderIcons/server-white-bg.png": 9167,
	"./HeaderIcons/server.png": 1239,
	"./HeaderIcons/software.png": 345,
	"./HeaderIcons/storage.png": 6631,
	"./HeaderIcons/switches.png": 8334,
	"./HeaderIcons/testimonials.png": 7786,
	"./HeaderIcons/vps.png": 2249,
	"./HeaderIcons/web-panel.png": 7399,
	"./HeroSectionImages/BlurredImage/certifications_compliances-thumbnail.jpg": 4013,
	"./HeroSectionImages/BlurredImage/cloud_services-thumbnail.jpg": 6163,
	"./HeroSectionImages/BlurredImage/colocation_services-thumbnail.jpg": 8557,
	"./HeroSectionImages/BlurredImage/dedicated_servers-thumbnail.jpg": 6249,
	"./HeroSectionImages/BlurredImage/engineers_service-thumbnail.jpg": 4721,
	"./HeroSectionImages/BlurredImage/it_consultation-thumbnail.jpg": 9646,
	"./HeroSectionImages/BlurredImage/rental_hardware-thumbnail.jpg": 6062,
	"./HeroSectionImages/BlurredImage/security-thumbnail.jpg": 4947,
	"./HeroSectionImages/BlurredImage/software_development-thumbnail.jpg": 776,
	"./HeroSectionImages/BlurredImage/vps_services-thumbnail.jpg": 8297,
	"./HeroSectionImages/DetailImages/about-us.webp": 3228,
	"./HeroSectionImages/DetailImages/careers.webp": 4979,
	"./HeroSectionImages/DetailImages/certifications_compliances.webp": 2264,
	"./HeroSectionImages/DetailImages/close-up-graduation-diploma.webp": 4882,
	"./HeroSectionImages/DetailImages/cloud_services.webp": 9458,
	"./HeroSectionImages/DetailImages/colocation_services.webp": 3786,
	"./HeroSectionImages/DetailImages/dedicated_servers.webp": 22,
	"./HeroSectionImages/DetailImages/engineers_service.webp": 8982,
	"./HeroSectionImages/DetailImages/it_consultation.webp": 8555,
	"./HeroSectionImages/DetailImages/partners.webp": 4083,
	"./HeroSectionImages/DetailImages/pri.webp": 3217,
	"./HeroSectionImages/DetailImages/rental_hardware.webp": 883,
	"./HeroSectionImages/DetailImages/security.webp": 7354,
	"./HeroSectionImages/DetailImages/software_development.webp": 2623,
	"./HeroSectionImages/DetailImages/testimonials.webp": 3676,
	"./HeroSectionImages/DetailImages/vps_services.webp": 6056,
	"./HeroSectionImages/certifications_compliances.webp": 7920,
	"./HeroSectionImages/cloud_services.webp": 3466,
	"./HeroSectionImages/colocation_services.webp": 7314,
	"./HeroSectionImages/dedicated_servers.webp": 3406,
	"./HeroSectionImages/engineers_service.webp": 3214,
	"./HeroSectionImages/it_consultation.webp": 9859,
	"./HeroSectionImages/priHome.webp": 5930,
	"./HeroSectionImages/rental_hardware.webp": 9979,
	"./HeroSectionImages/security.webp": 6402,
	"./HeroSectionImages/software_development.webp": 903,
	"./HeroSectionImages/vps_services.webp": 368,
	"./HomeImages/datacenter.webp": 5869,
	"./HomeImages/team-office.webp": 3380,
	"./HomeServices/1.png": 3545,
	"./HomeServices/2.png": 2834,
	"./HomeServices/3.png": 7051,
	"./HomeServices/4.png": 5396,
	"./HomeServices/5.png": 5341,
	"./HomeServices/6.png": 3718,
	"./LogoMain.png": 6390,
	"./NewUpdates/ISO.webp": 7800,
	"./NewUpdates/Registration.webp": 1002,
	"./NewUpdates/anz_certificate.webp": 1902,
	"./NewUpdates/icsi_certificate.webp": 4911,
	"./NewUpdates/redis_certificate.webp": 9206,
	"./NewUpdates/skillfront_certificate.webp": 9207,
	"./Partners/Apple.png": 6524,
	"./Partners/CyberPower.png": 9276,
	"./Partners/Dlink.png": 7300,
	"./Partners/Mikrotik.png": 8518,
	"./Partners/WD.png": 4839,
	"./Partners/acer.png": 4659,
	"./Partners/acronis.png": 3309,
	"./Partners/amd.png": 9442,
	"./Partners/aruba.png": 4485,
	"./Partners/asus.png": 202,
	"./Partners/baracuda.png": 643,
	"./Partners/cisco.png": 6785,
	"./Partners/crucial.png": 8575,
	"./Partners/dell.png": 7223,
	"./Partners/epson.png": 4561,
	"./Partners/f5.png": 1845,
	"./Partners/fortinet.png": 975,
	"./Partners/gigabyte.png": 7652,
	"./Partners/golidawai.png": 5367,
	"./Partners/hikvision.png": 5728,
	"./Partners/hp.png": 7254,
	"./Partners/huawei.png": 6361,
	"./Partners/ibm.png": 1182,
	"./Partners/ingram.png": 4262,
	"./Partners/intel.png": 7056,
	"./Partners/kingston.png": 9321,
	"./Partners/lenovo.png": 9043,
	"./Partners/micron.png": 4168,
	"./Partners/microsoft.png": 8052,
	"./Partners/molex.png": 2163,
	"./Partners/mycomputers.png": 1584,
	"./Partners/nokia.png": 1574,
	"./Partners/nutanix.png": 1007,
	"./Partners/nvidia.png": 6171,
	"./Partners/qnap.png": 2780,
	"./Partners/samsung.png": 2524,
	"./Partners/sandisk.png": 7997,
	"./Partners/sophos.png": 194,
	"./Partners/synlogy.png": 9113,
	"./Partners/toshiba.png": 8812,
	"./Partners/tplink.png": 7558,
	"./Partners/ubiquiti.png": 810,
	"./Partners/veam.png": 8335,
	"./Partners/vertiv.png": 3690,
	"./Services/24support.webp": 8004,
	"./Services/certificates/ISO.webp": 5577,
	"./Services/certificates/Registration.webp": 8621,
	"./Services/certificates/anz_certificate.webp": 5103,
	"./Services/certificates/icsi_certificate.webp": 6920,
	"./Services/certificates/redis_certificate.webp": 675,
	"./Services/certificates/skillfront_certificate.webp": 1344,
	"./Services/cloudAvailability.webp": 9191,
	"./Services/cloudCost.webp": 5525,
	"./Services/cloudFlexibility.webp": 7119,
	"./Services/cloudScalability.webp": 9739,
	"./Services/cloudSecurity.webp": 4102,
	"./Services/cloudSupport.webp": 9651,
	"./Services/compliance.webp": 3100,
	"./Services/comprehensiveServices.webp": 8161,
	"./Services/cost.webp": 9114,
	"./Services/costPRI.webp": 491,
	"./Services/costSaving.webp": 6508,
	"./Services/coverage.webp": 4045,
	"./Services/customerCare.webp": 8790,
	"./Services/customizableSolutions.webp": 1633,
	"./Services/customization.webp": 1252,
	"./Services/customizedSolutions.webp": 454,
	"./Services/dataCenter.webp": 7641,
	"./Services/enhancedSecurity.webp": 9123,
	"./Services/experiencedProfessionals.webp": 7551,
	"./Services/expert.webp": 4103,
	"./Services/expertSupport.webp": 9790,
	"./Services/fullControl.webp": 1295,
	"./Services/hand.webp": 9642,
	"./Services/highPerformance.webp": 8495,
	"./Services/innovation.webp": 9676,
	"./Services/innovationPRI.webp": 6437,
	"./Services/latest-technology.webp": 973,
	"./Services/man.webp": 6389,
	"./Services/networkConnectivity.webp": 7508,
	"./Services/note.webp": 399,
	"./Services/obsolescence.webp": 1090,
	"./Services/operationalEfficiency.webp": 108,
	"./Services/operations.webp": 3257,
	"./Services/reliability.webp": 9637,
	"./Services/reliableSupportPRI.webp": 7681,
	"./Services/rootAccess.webp": 2869,
	"./Services/scalability.webp": 1194,
	"./Services/scalableInfraPRI.webp": 4571,
	"./Services/security.webp": 3965,
	"./Services/serverSecurity.webp": 4846,
	"./Services/softwareCustom.webp": 1969,
	"./Services/softwareExpert.webp": 8134,
	"./Services/softwareInnovation.webp": 129,
	"./Services/softwareReliability.webp": 4470,
	"./Services/softwareScalability.webp": 4337,
	"./Services/solutions.webp": 9701,
	"./Services/support.webp": 2102,
	"./Services/trophy.webp": 6469,
	"./Services/trust.webp": 7867,
	"./Services/trustPRI.webp": 3480,
	"./Services/vpsPerformance.webp": 3344,
	"./WEBLOGO.webp": 5495,
	"./Website/banner-bk.webp": 2454,
	"./cropped-logo.webp": 5203,
	"./data-server.webp": 6106,
	"./dataserver.webp": 4285,
	"./logo1.png": 3660,
	"./press-release-banner.webp": 8914
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;